// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3g-wv","buttons":"Footer_buttons__3UNfD"};